import { colleges } from "../../constants/apiUrl";
import { IApiResponse } from "../../models/IAPIResponse";
import APIService from "../../helper/api-service";
import { urlBinder } from "../../helper/url-binder";
import { ICollegeData, IColleges } from "../../models/master/college";

 export default new (class CollegeService {
  public getCollege = async (
    id?: number
  ): Promise<IApiResponse<ICollegeData>> => {
    try {
      let endPoint = id?  urlBinder(colleges.GET_COLLEGE_WITH_ID, [id] ) : colleges.GET_COLLEGE_WITHOUT_ID ;
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<ICollegeData>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<ICollegeData>;
      } else {
        throw error;
      }
    }
  };

  public getColleges = async (
  ): Promise<IApiResponse<Array<IColleges>>> => {
    try {
      let endPoint = colleges.GET_ALL_COLLEGES;
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<Array<IColleges>>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<Array<IColleges>>;
      } else {
        throw error;
      }
    }
  };

  public createCollege = async (
    data: any
  ): Promise<IApiResponse<boolean|any>> => {
    try {
      let endPoint = colleges.CREATE_COLLEGE;
      const response = await APIService.postFormData(endPoint, data);
      return response.data as IApiResponse<boolean|any>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean|any>;
      } else {
        throw error;
      }
    }
  };

  public updateCollege = async (
    data: any,id:number
  ): Promise<IApiResponse<boolean>> => {
    try {
      let endPoint = urlBinder(colleges.UPDATE_COLLEGE, [`${id}`]);
      const response = await APIService.put(endPoint, data);
      return response.data as IApiResponse<boolean>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean>;
      } else {
        throw error;
      }
    }
  };

  public deleteCollege = async (id: number): Promise<boolean> => {
    try {
      let endPoint = urlBinder(colleges.DELETE_COLLEGE, [`${id}`]);
      const response = await APIService.delete(endPoint);
      return response.status === 204 ? true : false;
    } catch (error: any) {
      if (error.response) {
        return false as boolean;
      } else {
        throw error;
      }
    }
  };
})();
